import React, { useRef, useState } from 'react'

import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

import { postRequests } from '../../../../MyApi/sb/requests'

import PageHeader from '../../../../Components/UI/PageHeader'
import AddRequest from '../../../../Components/sb/requests/requestsStore/AddRequest'
import { useTranslation } from 'react-i18next'


const RequestsStore = () => {
const [requestName ,setRequestName]= useState("")
const [description ,setDescription]= useState("")
const [imageFile ,setImageFile] = useState("")
const [slug, setSlug] =useState("")
const [type, setType] = useState([])
const [loan,setLoan] =useState(1)
const  [active, setActive]= useState(1)
const [companyId , setCompanyId] = useState("")
const fileInputRef = useRef(null);
const {i18n} =useTranslation()
const lang =i18n.language
 const mutation = useMutation(["postRequests",lang] , (postData)=>postRequests(postData,lang) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
        setRequestName("")
        setDescription("")
        setImageFile("")
        setSlug("")
        setType([])
        setImageFile("")
        fileInputRef.current.value = ""
    }, 
    onError:(error)=>{
       toast.error(`${error.response.data.message}`)
    }
 })

 const handlePostRequest =()=>{
  const formData = new FormData
  formData.append("name" ,requestName )
  formData.append("description" ,description )
  formData.append("image" ,imageFile )
  formData.append("slug" ,slug )
  formData.append("type" ,JSON.stringify(type) )
  formData.append("loan" ,loan )
  formData.append("active" ,active )
  formData.append("sb_company_id" ,companyId )
    mutation.mutate(formData)
 }
 const isDisabled= ()=>{
   return !(requestName && description && imageFile && slug && type  )

 }
 
  return ( 

    <div>
        <PageHeader title="Add Request" isLoading={mutation.isLoading} showBack={true} saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <AddRequest fileInputRef={fileInputRef}  loan={loan} requestName={requestName} description={description} slug={slug} type={type} setRequestName={setRequestName} setDescription={setDescription} setImageFile={setImageFile} setSlug={setSlug} setType={setType}  setLoan={setLoan} setActive={setActive} active={active}  setCompanyId={setCompanyId}/>
    </div>
  )
}

export default RequestsStore